import React from 'react'

const FooterBottom = () => {
  return (
    <div
      style={{
        borderTop: "1px solid #1e2228",
        padding: "20px 0",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "10px",
      }}
    >
      <p style={{
        fontFamily: "'JetBrains Mono', monospace",
        fontSize: "12px",
        color: "#4a5568",
      }}>
        © 2026 <span style={{ color: "#ff014f" }}>Biprodas Barai</span>. All rights reserved.
      </p>
      <p style={{
        fontFamily: "'JetBrains Mono', monospace",
        fontSize: "12px",
        color: "#4a5568",
      }}>
        Built with <span style={{ color: "#ff014f" }}>♥</span> in Bangladesh
      </p>
    </div>
  );
}

export default FooterBottom;